import { rest } from 'msw';
import { saveResponse } from './fixtures/paymentSubmissions';

export const paymentSubmissionsHandlers = [
  rest.post('*/re/v1/reimbursement-request',
    (req, res, ctx) => res(
      ctx.status(200),
      ctx.json(saveResponse),
    )),
];
